import Link from 'components/common/Link/Link';
import { FC, ReactNode } from 'react';
import { Logs } from '../types';
import './styles.scss';

type LogsListProps = {
  logs: Logs;
};

function cutLog(log: string): string {
  return log.length < 40 ? log : `${log.slice(0, 18)}...${log.slice(-18)}`;
}

const LogsList: FC<LogsListProps> = ({ logs }: LogsListProps) => (
  <div className="LogsView__LogsList">
    {logs.map(
      (log: string): ReactNode => (
        <Link href={`events?filter=$logfile='${log}'`} className="link">
          {cutLog(log)}
        </Link>
      ),
    )}
  </div>
);

export default LogsList;
